import React from "react";
import { connect } from "react-redux";

import "./Header.css";

import { tryLogout } from "../../../actions/authActions";

class Header extends React.Component {
    onLogoutClick = () => this.props.tryLogout();

    render() {
        return (
            <React.Fragment>
                <div className="header-component ui secondary pointing menu">
                    <div className="ui container">
                        {/* <div className="item">
                            <img className="logo" src="/logo.png" alt="logo" />
                        </div> */}
                        <h3 className="item header">Pracownik Medcom</h3>
                        <div className="right menu">
                            <h3 className="item header">{` ${this.props.currentUser.lname} ${this.props.currentUser.fname}`}</h3>
                            <div className="item">
                                <button className="ui button" type="button" onClick={this.onLogoutClick}>Wyloguj</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({ currentUser: state.user.current });

export default connect(mapStateToProps, { tryLogout })(Header);